// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1lLTF","actions":"GroupTable_actions__1VaES","deleteModalFooter":"GroupTable_deleteModalFooter__2NPvN"};